type EntityWithLocation = { baneDataLocationId: string; baneDataLocationName: string }

export const mapToLocations = (items: EntityWithLocation[]) => {
  const locationMap = items.reduce<Record<string, string>>((agg, { baneDataLocationId, baneDataLocationName }) => {
    agg[baneDataLocationId] = baneDataLocationName
    return agg
  }, {})
  return Object.entries(locationMap).map(([locationId, locationName]) => ({ locationId, locationName }))
}
